import { Stack, Typography } from '@mui/material';
import { PocketflowsCampaign } from '../../../../types/marketing';

interface Props {
  statistics: PocketflowsCampaign['statistics'];
  type: 'bounced' | 'opened' | 'clicked';
}

function CampaignStatistic({ statistics, type }: Props) {
  const numerator =
    statistics?.emails?.[
      type === 'bounced'
        ? 'hard_bounced'
        : type === 'clicked'
        ? 'clicked'
        : 'opened'
    ] || 0;
  const denominator =
    statistics?.emails?.[
      type === 'bounced' ? 'sent' : type === 'clicked' ? 'opened' : 'delivered'
    ] || 0;
  const label =
    type === 'bounced' ? 'Bounced' : type === 'clicked' ? 'Clicked' : 'Opened';

  const percentage =
    denominator <= 0 ? 0 : Math.round((numerator / denominator) * 100);

  const isNotAvailable =
    type === 'clicked' && statistics?.emails?.clicked === null;

  if (isNotAvailable) return null;

  return (
    <Stack alignItems="center">
      <Typography variant="body2" fontWeight={700}>
        {percentage}%
      </Typography>
      <Typography variant="body2">{label}</Typography>
    </Stack>
  );
}

export default CampaignStatistic;
